<template>
  <div class="amount-card">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ cardTitle }}</span>
      </div>
      <div class="card-body">
        <p class="card-body-amount" :style="colorStyle">{{ Math.ceil(amount) }}</p>
        <p class="card-body-desc" :style="colorStyle">{{ desc }}</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "OrderAmountCard",
  components: {},
  props: {
    cardTitle: {
      type: String,
      default: ''
    },
    amount: {
      type: null,
      default: 0
    },
    desc: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  watch: {
  },
  data() {
    return {
    };
  },
  computed: {
    colorStyle () {
      return {
        color: this.color
      }
    }
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped>
.amount-card {
  height: 100%;
}
.el-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.el-card >>> .el-card__body {
  flex: 1;
}
.card-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: .4rem;
}
.card-body-amount {
  flex: 1;
  font-size: .8rem;
  align-content: center;
  //color: #F86A72;
}
.card-body-desc {
  flex: 1;
  font-size: .4rem;
  //color: #F86A72;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/common/OrderAmountCard.vue